import { Link } from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";

const SingleMenuItem = ({ url, icon, label, target }) => {
  return (
    <Link
      as={RouterLink}
      to={url}
      fontSize={{ base: "xl", md: "sm", lg: "sm" }}
      letterSpacing="wide"
      mr={{ base: "0", md: "0", lg: "5" }}
      display="flex"
      alignItems="center"
      // color="#f2f2f2"
      color="white"
      fontWeight="500"
      _hover={{ textDecor: "none", color: "wheat" }}
      onClick={() => {
        window.scrollTo({ top: "0", behavior: "auto" });
      }}
      _focus={{ outline: "none" }}
      target={target}
    >
      {icon}
      {label}
    </Link>
  );
};

export default SingleMenuItem;
